<div class="content-container mt-3">
  <div class="container p-0">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <div class="d-flex flex-column mt-3 w-100">
        <div>
          <button
            type="button"
            class="btn-close align-self-end pe-3"
            aria-label="Close"
            (click)="activeModal.dismiss()"
          >
          </button>
          <h3 class="ps-3">Attention: Transfer of keepership pending</h3>
        </div>
        <hr class="horizontal-line" />
        <div class="mt-3 px-3">
          <p>It appears you haven't completed the payment to finalise the transfer process.</p>
          <p>
            Without completing the payment, the transfer of keepership cannot be processed, your new pet will not be added to your account and will revert to the breeder’s account.
          </p>
          <p>To complete the transfer, please proceed to complete the payment now.</p>
        </div>
      </div>
      <hr class="horizontal-line" />
      <button
        class="btn btn-secondary text-white btn-lg mt-3 mb-5 align-self-end me-4 modal-button"
        (click)="buyTok()"
      >
        <img
          width="28"
          src="assets/images/identibase/whitepawlarge.png"
          class="modal-button-image"
          alt="whitepawlarge"
        />
        Complete payment
      </button>
    </div>
  </div>
</div>
